import styled from 'styled-components';
import Button from '@sdk/components/ui/buttons/Button';

export const BackButton = styled(Button)`
  width: 160px;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.bodyBg};
`;
